import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getcourseAPi, createcourseAPi,  uploadcourseAPi, deletecourseApi } from "../../../ApiUrl";
import { toast } from "react-toastify";

export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};
// create course
export const createcourse = createAsyncThunk('createcourse/course', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createcourseAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updatecourse = createAsyncThunk('updatecourse/course', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadcourseAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get course
export const getcourse = createAsyncThunk('getcourse/course', async () => {
    try {
        const response = await axios.get(`${getcourseAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'courses' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete course
export const deletecourses = createAsyncThunk('deletecourses/course', async (courseid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletecourseApi}/${courseid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'courseid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const courseSlice = createSlice({
    name: 'course',
    initialState: {
        courses: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create course
            .addCase(createcourse.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createcourse.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createcourse.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update course
            .addCase(updatecourse.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatecourse.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updatecourse.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getcourses
            .addCase(getcourse.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getcourse.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.courses = action.payload;
            })
            .addCase(getcourse.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete courses
            .addCase(deletecourses.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletecourses.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.courses.data = state.courses.data.filter(courses => courses.courseid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletecourses.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default courseSlice.reducer;
